const VIMEO_CDN_DOMAIN = 'vimeocdn.com'
const VIMEO_QUALITY_PARAM = '-d?mw=1100'
const VIMEO_THUMBNAIL_PATTERN = /-d.*$/

export function prepareVideoThumbnailUrl(url: string | undefined) {
  // From https://i.vimeocdn.com/video/1860228053-e789547272a7e709aa54f980126dc389fa1f1ca26f4f1d2966f051cb8b2ffdb3-d_295x166
  // to
  // This https://i.vimeocdn.com/video/1860228053-e789547272a7e709aa54f980126dc389fa1f1ca26f4f1d2966f051cb8b2ffdb3-d?mw=1100
  if (!url || typeof url !== 'string') return ''
  if (!url.includes(VIMEO_CDN_DOMAIN)) return url
  return url.replace(VIMEO_THUMBNAIL_PATTERN, VIMEO_QUALITY_PARAM)
}
